import styled from 'styled-components'
import { Dialog } from '@material-ui/core'

export const StyledDialog = styled(Dialog)`
  .title {
    padding: 24px;
  }
  .content {
    padding: 0 24px 40px 24px;
  }
  .actions {
    padding: 0 24px 24px 24px;
    display: flex;
    min-width: 138px;
    align-items: center;
    justify-content: flex-end;

    button {
      min-width: 138px;
    }

    button + button {
      margin-left: 8px;
    }
  }
` as any
